import { render, staticRenderFns } from "./ResultadosFotosEvento.vue?vue&type=template&id=1dbf308f&"
import script from "./ResultadosFotosEvento.vue?vue&type=script&lang=js&"
export * from "./ResultadosFotosEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports